import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { BlockBaseProps } from "@store/Components/Common/Block/Block";
import { variants } from "@store/Components/Common/Block/variant/config";

export enum BlockVariantSide {
    Both = "Both",
    Top = "Top",
    Bottom = "Bottom",
}

export interface BlockVariantBaseProps {
    containerCss?: StyledProp<BlockBaseProps>;
    spacerCss?: StyledProp<BlockBaseProps>;
    wrapperCss?: StyledProp<BlockBaseProps>;
}

const getVariantDefaultProps = () => {
    const defaults: any = {};

    for (const [key, value] of Object.entries(variants)) {
        defaults[key] = (value as any).defaultProps ?? {};
    }

    return defaults;
};

export const variantDefaultProps = getVariantDefaultProps();
